import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'
import { cloneDeep } from '@/global/utils/utils'
import { FormDataBuilder } from '@/global/services/helpers/formDataBuilder'
import { showDetailsAction, deleteAction, activationAction } from '@/global/components/table/helpers/tableActions'

const TABLE_COMPONENT_KEY = 'trackers'
export default {
  data () {
    return {
      informationDialogConfig: {
        openDialog: false,
        message: '',
        title: '',
        positiveBtnText: '',
        negativeBtnText: this.$t('base.cancel'),
        callbackFn: () => {}
      },
      trackerChangeCompanyDialogConfig: {
        openDialog: false,
        positiveButtonText: this.$t('base.save'),
        negativeButtonText: this.$t('base.cancel'),
        title: '',
        callback: () => this.onChangeCompanyCallback()
      },
      trackerChangeCompanyFormData: {},
      trackerChangeCompanyFormValidationErrors: {},
      showTrackerChangeCompanyLoader: false,
      mainTableKey: TABLE_COMPONENT_KEY
    }
  },

  computed: {
    tableRowActions () {
      return [
        {
          ...showDetailsAction(this.$t, (event) => this.showEdit(event)),
          visible: !!this.permissions?.canUpdate
        },
        {
          ...activationAction(this.$t, (event) => this.onTrackerActivation(event), (event) => !event?.data?.deactivated_at),
          visible: (event) => {
            return !event?.data?.master_app && !!this.permissions?.canActivate
          }
        },
        {
          ...deleteAction(this.$t, (event) => this.onTrackerDelete(event)),
          visible: (event) => {
            return !event?.data?.master_app && !!this.permissions?.canDelete
          }
        },
        {
          label: this.$t('base.change_company'),
          icon: 'mdi-factory',
          visible: !!this.permissions?.canChangeCompany,
          click: (event) => this.onChangeCompany(event)
        }
      ]
    }
  },

  methods: {
    showEdit (event) {
      this.navigatesToTableDetailsView('TrackerView', event, { imei: event?.data?.imei })
    },

    onTrackerActivation (event) {
      const {
        deactivated_at: deactivatedAt,
        id,
        imei
      } = event?.data || {}

      if (!id) {
        return
      }

      const title = !deactivatedAt ? this.$t('base/tracker.deactivate') : this.$t('base/tracker.activate')
      this.$set(this.informationDialogConfig, 'title', title + (imei ? ' - ' + imei : ''))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('base/tracker.confirm_deactivation') : this.$t('base/tracker.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.handleTrackerActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async handleTrackerActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.mainTableKey] || {}
        await api('base').patch(`tracker/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onTrackerDelete (event) {
      const {
        id,
        imei
      } = event?.data || {}

      if (!id) {
        return
      }

      const title = this.$t('base/tracker.delete')
      this.$set(this.informationDialogConfig, 'title', title + (imei ? ' - ' + imei : ''))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('base/tracker.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.handleTrackerDeletion(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async handleTrackerDeletion (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.mainTableKey] || {}

        await api('base').delete(`tracker/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onChangeCompany (event) {
      const { data } = event || {}
      const { imei } = data || {}
      const clonedData = cloneDeep(data)
      this.trackerChangeCompanyFormData = {
        id: clonedData?.id
      }
      this.$set(this.trackerChangeCompanyDialogConfig, 'title', this.$t('base.change_company_title') + (imei ? ' - ' + imei : ''))
      this.$set(this.trackerChangeCompanyDialogConfig, 'openDialog', true)
    },

    async onChangeCompanyCallback () {
      try {
        this.showTrackerChangeCompanyLoader = true
        if (!this.trackerChangeCompanyFormData?.id) {
          return
        }

        const formDataBuilder = new FormDataBuilder()
        const formData = formDataBuilder.build(this.trackerChangeCompanyFormData)
        formData.append('_method', 'PATCH')

        await api('base').post(`tracker/${this.trackerChangeCompanyFormData.id}/change-company`, formData)

        const { fetchData } = registeredTableHandlers[TABLE_COMPONENT_KEY] || {}
        this.closeTrackerChangeCompanyDialog()
        // refresh table after success import
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        this.trackerChangeCompanyFormValidationErrors = exception?.response?.data?.errors || {}
        console.error(exception)
      }
      finally {
        this.showTrackerChangeCompanyLoader = false
      }
    },

    closeTrackerChangeCompanyDialog () {
      this.$set(this.trackerChangeCompanyDialogConfig, 'openDialog', false)
    },

    onClearTrackerChangeCompanyValidationErrors (key) {
      if (this.trackerChangeCompanyFormValidationErrors?.[key]) {
        this.$delete(this.trackerChangeCompanyFormValidationErrors, key)
      }
    }
  }
}
